module.exports = __webpack_public_path__ + "img/tab1.1dc9c146.png";